var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" You should be receiving an invitation to design your page in Captura Yearbooks soon! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }